import { app } from '../../../../app';
import { Controller } from './added-applications-list.controller';
app.component('companyApplicationsList', {
    bindings: {applications: '<'},
    controller: Controller,
    templateUrl: require('./added-applications-list.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/added-applications-list/added-applications-list.component.js